'use strict'

/**
 * HSVColor
 * Workflow: lightweight value container for HSV components.
 */
class HSVColor {
    /**
     * @param {number} h Hue in degrees.
     * @param {number} s Saturation (0..1).
     * @param {number} v Value (0..1).
     */
    constructor(h = 0.0, s = 0.0, v = 0.0) {
        this.h = h
        this.s = s
        this.v = v
    }
}

export default HSVColor
